/** Pending game-creation tasks (survive refresh). Same pattern as creationProgress. */
const KEY = 'game_creation_pending_tasks';

export function loadPendingTasks() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function savePendingTasks(tasks) {
  try {
    localStorage.setItem(KEY, JSON.stringify(tasks));
  } catch {}
}

export function addPendingTask(gameId, step, gameTitle = '', chapterNumber = null) {
  const tasks = loadPendingTasks();
  const matches = (t) =>
    t.gameId === gameId &&
    t.step === step &&
    (step !== 'chapter' || t.chapterNumber === chapterNumber);
  if (tasks.some(matches)) return tasks;
  tasks.push({ gameId, step, gameTitle, chapterNumber, startedAt: Date.now() });
  savePendingTasks(tasks);
  return tasks;
}

export function removePendingTask(gameId, step, chapterNumber = null) {
  const tasks = loadPendingTasks().filter((t) => {
    if (t.gameId !== gameId || t.step !== step) return true;
    if (step === 'chapter') return t.chapterNumber !== chapterNumber;
    return false;
  });
  savePendingTasks(tasks);
  return tasks;
}

export function isPending(gameId, step, chapterNumber = null) {
  return loadPendingTasks().some((t) => {
    if (t.gameId !== gameId || t.step !== step) return false;
    if (step === 'chapter') return t.chapterNumber === chapterNumber;
    return true;
  });
}
